export const NUMERIC_CHARACTERS = "0123456789";
export const ALPHABETICAL_UPPERCASE_CHARACTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const ALPHABETICAL_LOWERCASE_CHARACTERS = "abcdefghijklmnopqrstuvwxyz";
export const ALPHA_NUMERIC_CHARACTERS = `${ALPHABETICAL_UPPERCASE_CHARACTERS}${ALPHABETICAL_LOWERCASE_CHARACTERS}${NUMERIC_CHARACTERS}`;
